module.exports = __webpack_public_path__ + "img/gift_5.ba1e0a78.webp";